import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FiMenu,
  FiBell,
  FiUser,
  FiLogOut,
} from "react-icons/fi";
import { Dropdown } from "react-bootstrap";
import user from "../assets/images/user.jpg";
import logo from "../assets/images/king999-logo.png";

const pageMeta = {
  "/": { title: "Dashboard", eyebrow: "Overview" },
  "/all-user-list": { title: "All Users", eyebrow: "User Management" },
  "/active-user-list": { title: "Active Users", eyebrow: "User Management" },
  "/inactive-user-list": { title: "Inactive Users", eyebrow: "User Management" },
  "/kyc-pending": { title: "KYC Pending", eyebrow: "Verification" },
  "/kyc-verify": { title: "KYC Verified", eyebrow: "Verification" },
  "/kyc-reject": { title: "KYC Rejected", eyebrow: "Verification" },
  "/deposit-pending": { title: "Pending Deposits", eyebrow: "Manual Payment" },
  "/deposit-approve": { title: "Approved Deposits", eyebrow: "Manual Payment" },
  "/deposit-rejected": { title: "Rejected Deposits", eyebrow: "Manual Payment" },
  "/withdrawal-pending": { title: "Pending Withdrawals", eyebrow: "Withdrawals" },
  "/withdrawal-approve": { title: "Approved Withdrawals", eyebrow: "Withdrawals" },
  "/withdrawal-rejected": { title: "Rejected Withdrawals", eyebrow: "Withdrawals" },
  "/penalty-history": { title: "Penalty History", eyebrow: "Transactions" },
  "/bonus-history": { title: "Bonus History", eyebrow: "Transactions" },
  "/deposit-history": { title: "Deposit History", eyebrow: "Transactions" },
  "/withdraw-history": { title: "Withdrawal History", eyebrow: "Transactions" },
  "/penalty-report": { title: "Penalty Report", eyebrow: "Reports" },
  "/bonus-report": { title: "Bonus Report", eyebrow: "Reports" },
  "/deposit-report": { title: "Deposit Report", eyebrow: "Reports" },
  "/withdraw-report": { title: "Withdrawal Report", eyebrow: "Reports" },
  "/admin-list": { title: "Admin List", eyebrow: "Admin Management" },
  "/add-admin": { title: "Add Admin", eyebrow: "Admin Management" },
  "/game-settings": { title: "Dragon Tiger Settings", eyebrow: "Game Settings" },
  "/aviator-game-settings": { title: "Aviator Settings", eyebrow: "Game Settings" },
  "/general-settings": { title: "General Settings", eyebrow: "Settings" },
  "/content-list": { title: "Content List", eyebrow: "Settings" },
  "/privacy-policy": { title: "Privacy Policy", eyebrow: "Settings" },
  "/mails": { title: "Mail List", eyebrow: "Settings" },
  "/add-mails": { title: "Add Mail", eyebrow: "Settings" },
  "/profile": { title: "Profile", eyebrow: "Account" },
};

const getPageMeta = (pathname) => {
  if (pageMeta[pathname]) return pageMeta[pathname];

  if (pathname.startsWith("/user-details/")) {
    return { title: "User Details", eyebrow: "User Management" };
  }

  if (pathname.startsWith("/ledger/")) {
    return { title: "User Ledger", eyebrow: "User Management" };
  }

  return { title: "Admin Dashboard", eyebrow: "Management Console" };
};

const AppHeader = ({ sidebarOpen, setSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { title, eyebrow } = getPageMeta(location.pathname.toLowerCase());

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  return (
    <header className="app-header">
      <div className="app-header-left">
        <button
          type="button"
          className="header-icon-button sidebar-toggle-button"
          aria-label="Toggle sidebar"
          aria-expanded={sidebarOpen}
          onClick={() => setSidebarOpen((prev) => !prev)}
        >
          <FiMenu />
        </button>

        <div className="app-brand-sm d-lg-none">
          <a href="/" aria-label="Dashboard home">
            <img src={logo} className="logo" alt="logo brand" />
          </a>
        </div>

        <div className="header-page-meta d-none d-sm-block">
          <span className="header-eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
        </div>
      </div>

      <div className="app-header-actions">
        {/* <button
          type="button"
          className="header-icon-button notification-button d-none d-md-inline-flex"
          aria-label="Notifications"
        >
          <FiBell />
          <span className="notification-dot">3</span>
        </button> */}

        <Dropdown align="end" className="profile-dropdown">
          <Dropdown.Toggle
            variant="light"
            id="profile-dropdown"
            className="profile-toggle"
          >
            <img
              src={user}
              alt="user"
              width="38"
              height="38"
              className="rounded-circle object-fit-cover"
            />
            <span className="profile-copy d-none d-md-flex">
              <strong>{localStorage.getItem("name") || "Admin"}</strong>
              <small>Administrator</small>
            </span>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="/profile">
              <FiUser />
              Profile
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleLogout} className="text-danger">
              <FiLogOut />
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  );
};

export default AppHeader;
